import { ID } from './StandartId';

export const FORM = {
  LOGIN: ID.FORM + "login",
};
